import { Menu, MenuButton, MenuList, MenuItem, Box } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useContext, useState } from "react";
import ManoshalaCareService from "../../services/ManoshalaCare";
import { appContext } from "../../Context/AppContext";
import { useNavigate } from "react-router-dom";
export const SingleCareRow = ({ props }: any) => {
  const { setChatId } = useContext(appContext);
  const navigate = useNavigate();
  const {
    user_id,
    email,
    phone,
    concerns,
    type,
    name,
    status,
    _id,
    care_date,
    care_time,
  } = props;
  const [showingStatus, setShowingStatus] = useState(status);
  const handleClick = () => {
    ManoshalaCareService.updateStatus(
      _id,
      showingStatus === "PENDING" ? "RESOLVED" : "PENDING"
    )
      .then((res: any) => {
        setShowingStatus(showingStatus === "PENDING" ? "RESOLVED" : "PENDING");
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  const handleSendMessage = () => {
    setChatId(user_id);
    navigate("/manoshalacare/chat");
  };
  return (
    <tr>
      <td>{user_id}</td>
      <td>{name}</td>
      <td>{email}</td>
      <td>{phone}</td>
      <td>
        {care_date
          .split("/")
          .map((part: any, index: any, arr: any) =>
            index === 0 ? arr[1] : index === 1 ? arr[0] : part
          )
          .join("/")}
        -{care_time}
      </td>
      <td>{type}</td>
      <td>{concerns && concerns.length > 0 ? concerns.join(",") : null}</td>
      <td>
        <Menu>
          <MenuButton
            color={showingStatus === "PENDING" ? "orange" : "green"}
            fontWeight="bold"
          >
            {showingStatus} <ChevronDownIcon />
          </MenuButton>
          <MenuList>
            <MenuItem onClick={handleClick}>
              <Box
                color={showingStatus === "RESOLVED" ? "orange" : "green"}
                fontWeight="bold"
              >
                {showingStatus === "PENDING" ? "RESOLVED" : "PENDING"}
              </Box>
            </MenuItem>
          </MenuList>
        </Menu>
      </td>
      <td>
        {" "}
        <div className="d-flex align-items-center">
          <button
            type="button"
            disabled={type !== "USER"}
            className="btn action-btn"
            onClick={handleSendMessage}
          >
            Message
          </button>
        </div>
      </td>
    </tr>
  );
};
